function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import StyledParagraph from './Paragraph.style';
import { getCleanProps } from '../../../utility/getCleanProps';
Paragraph.propTypes = {
  /** the variant of Paragraph to show  */
  variant: PropTypes.oneOf(['regular', 'semibold', 'bold', 'overline']),

  /** renders the right color on a dark background */
  isOnDarkBg: PropTypes.bool,

  /** ref to the paragraph */
  textRef: PropTypes.shape({
    current: PropTypes.any
  }),

  /** the paragraph content */
  children: PropTypes.node.isRequired
};
Paragraph.defaultProps = {
  variant: 'regular',
  isOnDarkBg: false
};
export function Paragraph(_ref) {
  var children = _ref.children,
      textRef = _ref.textRef,
      restProps = _objectWithoutProperties(_ref, ["children", "textRef"]);

  return /*#__PURE__*/React.createElement(StyledParagraph, _extends({}, getCleanProps(restProps), {
    ref: textRef
  }), children);
}